var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"flat":""},on:{"click":_vm.goToPostsList}},[_vm._v("Volver a "+_vm._s(_vm.link_name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }